

import React from 'react';
import { Link } from 'react-router-dom';
// import { FaBars, FaPlus } from 'react-icons/fa';

const Roadmaps = () => {
  const roleBasedRoadmaps = [
    { title: 'Frontend', path: '/fr', category: 'Role-based' },
    { title: 'Backend', path: '/br', category: 'Role-based' },
    { title: 'Full Stack', path: '/fsr', category: 'Role-based' },
    { title: 'AI / ML', path: '/aiml', category: 'Role-based' },
    { title: 'Data Science', path: '/dsr', category: 'Role-based' },
    { title: 'Data Analyst', path: '/dar', category: 'Role-based', isNew: true }, // Kept "New" badge as in reference
    { title: 'DevOps', path: '/devr', category: 'Role-based' },
    
  ];

  const skillBasedRoadmaps = [
    { title: 'Python', path: '/pr', category: 'Skill-based' },
    { title: 'Java', path: '/jr', category: 'Skill-based' },
    { title: 'C++', path: '/cpp', category: 'Skill-based' },
    { title: 'DSA', path: '/dsar', category: 'Skill-based' },
  ];

  return (
    <div className="min-h-screen bg-[#0A0F20] text-white">
      {/* Navigation Bar */}
     

      {/* Main Content */}
      <div className="max-w-6xl mx-auto py-12 px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Developer Roadmaps</h1>
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto">
            roadmap.sh is a community effort to create roadmaps, guides and other educational content to help guide developers in picking up a path and guide their learnings.
          </p>
        </div>

        {/* Role-based Roadmaps */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold mb-4">Role-based Roadmaps</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {roleBasedRoadmaps.map((roadmap, index) => (
              <Link
                key={index}
                to={roadmap.path}
                className="relative flex items-center justify-center border border-gray-600 rounded-md py-3 px-4 text-sm hover:bg-gray-800 transition-colors"
              >
                {roadmap.isNew && (
                  <span className="absolute top-2 right-2 bg-purple-500 text-white text-xs px-2 py-0.5 rounded">
                    New
                  </span>
                )}
                {roadmap.title}
              </Link>
            ))}
          </div>
          {/* <div className="mt-6 text-center">
            <Link
              to="/create-roadmap"
              className="flex items-center justify-center gap-2 border border-gray-600 rounded-md py-3 px-4 text-sm hover:bg-gray-800 transition-colors mx-auto w-fit"
            >
              <FaPlus /> Create your own Roadmap
            </Link>
          </div> */}
        </div>

        {/* Skill-based Roadmaps */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Skill-based Roadmaps</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {skillBasedRoadmaps.map((roadmap, index) => (
              <Link
                key={index}
                to={roadmap.path}
                className="flex items-center justify-center border border-gray-600 rounded-md py-3 px-4 text-sm hover:bg-gray-800 transition-colors"
              >
                {roadmap.title}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Floating Button (Placeholder) */}
      {/* <div className="fixed bottom-6 right-6">
        <button className="bg-white text-black rounded-full p-3">
          <span className="w-6 h-6 block" />
        </button>
      </div> */}
    </div>
  );
};

export default Roadmaps;